import { saveSync } from 'save-file';

const downloadFile = (data, fileName) => {
    saveSync(data, fileName);
};

export default downloadFile;